import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useUsers, SCREENS } from '../../../hooks';
import BusinessIcon from '@mui/icons-material/Business';

const UserFirmsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const customRowActions = useCallback(() => [
    {
      type: 'manageFirms',
      label: t('userFirms.manageFirms'),
      color: 'primary',
      icon: <BusinessIcon />,
    },
  ], [t]);

  const handleRowAction = useCallback((actionType, row) => {
    if (actionType === 'manageFirms') {
      navigate(`/applications/user-firms/${row.id}`);
      return true;
    }
    return false;
  }, [navigate]);

  return (
    <DynamicCrudPage
      entityType="users"
      screen={SCREENS.USERS}
      hook={useUsers}
      addButtonTextKey="table.actions.addUser"
      entityTypeForDataTable="user"
      showAddButton={false}
      hideDefaultActions={true}
      customRowActions={customRowActions}
      onRowAction={handleRowAction}
      exportButton={false}
    />
  );
};

export default UserFirmsPage;
